import { george, pr, theme, ui } from "aaa";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { CancelButton } from "../components/CancelButton";
import { ContinueButton } from "../components/ContinueButton";
import { ScreenWithBottomAction } from "../components/ScreenWithBottomAction";
import { JuniorRoutes } from "../JuniorRoutes";

export const JuniorActivationDownloadApp = () => {
    const handleClose = () => {
        pushRoute(JuniorRoutes.DETAIL);
    };

    const handleContinue = () => {
        pushRoute(JuniorRoutes.ACTIVATION_ACTIVATE_APP);
    };

    return (
        <ScreenWithBottomAction
            title={ui.__("gJunior.activation.download.title")}
            ContinueButton={<ContinueButton
                messageId="gJunior.activate.stepper.next"
                onClick={handleContinue}
            />}
            CancelButton={<CancelButton onClick={handleClose} />}
        >

            <george.Card
                elevated={false}
                style={{
                    borderRadius: theme.BORDER_RADIUS_LARGE,
                    padding: theme.MARGIN,
                    marginTop: theme.MARGIN_LARGE,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    src={require("../../../assets/gJunior/app_icon.svg")}
                    alt=""
                    style={{
                        width: 56,
                        height: 56,
                        marginTop: -theme.MARGIN_XLARGE,
                    }}
                />
                <div
                    style={{
                        padding: theme.MARGIN,
                        textAlign: "center",
                    }}
                >
                    <pr.P_18_TITLE
                        style={{
                            fontWeight: 700,
                            textAlign: "center",
                            lineHeight: "24px",
                        }}
                    >
                        {ui.__("gJunior.activation.download.code.title")}
                    </pr.P_18_TITLE>
                    <pr.P_16_CONTENT
                        style={{
                            marginTop: theme.MARGIN_SMALL,
                            textAlign: "center",
                        }}
                    >
                        {ui.__("gJunior.activation.download.code.description")}
                    </pr.P_16_CONTENT>
                </div>
                <img
                    src={require("../../../assets/gJunior/qrcode-appstore.svg")}
                    alt=""
                    style={{
                        width: 180,
                        height: 180,
                        display: "block",
                    }}
                />

            </george.Card>
            <pr.P_16_CONTENT
                style={{
                    marginTop: theme.MARGIN,
                    marginBottom: theme.MARGIN,
                }}
            >
                {ui.__("gJunior.activation.download.note")}
            </pr.P_16_CONTENT>
        </ScreenWithBottomAction>
    );
};


// WEBPACK FOOTER //
// ./src/components/gJunior/activationStep/JuniorActivationDownloadApp.tsx